var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"email"),React.createElement("g",{"id":"f17af055-f5be-48d9-99a7-b801d52c5f30","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b00dc381-e789-4a8b-a9bd-de8cf06b6477","data-name":"ikonky"},React.createElement("path",{"id":"f508a20e-a4b6-4bfa-9f36-e91e186484dd","data-name":"email","d":"M20.73,19H0V7.53L1.73,6.28V0H19V6.28l1.73,1.25ZM3.45,10V1.73H17.27V10l-6.91,4.73Zm12.1-.06H5.18V8.15H15.55Zm0-4.1V7.54H5.18V5.8ZM10.5,5.18H5.18V3.45l5.32,0Z","fillRule":"evenodd"})))]);
}

Email.defaultProps = {"viewBox":"0 0 20.73 19"};

module.exports = Email;

Email.default = Email;
